import React from "react";

export interface Param {
  name: string;
  type: string;
  required: boolean;
  description: string;
}

interface ParamTableProps {
  title: string;
  params: Param[];
}

export const ParamTable: React.FC<ParamTableProps> = ({ title, params }) => (
  <div className="mt-6">
    <h4 className="text-sm font-semibold mb-3 uppercase tracking-wide text-white">{title}</h4>
    <div className="border border-white/[0.08] bg-white/[0.04] rounded-xl overflow-hidden ">
      <table className="w-full text-sm ">
        <thead>
          <tr className="bg-gray-50 border-b text-white/90  bg-white/[0.04] border-white/[0.08]">
            <th className="text-left px-4 py-2.5 font-medium">Parameter</th>
            <th className="text-left px-4 py-2.5 font-medium">Type</th>
            <th className="text-left px-4 py-2.5 font-medium">Required</th>
            <th className="text-left px-4 py-2.5 font-medium">Description</th>
          </tr>
        </thead>
        <tbody>
          {params.map((p, i) => (
            <tr key={p.name} className={i % 2 === 0 ? "bg-web-background" : "bg-white/[0.04]"}>
              <td className="px-4 py-2.5 font-mono text-white/70 text-xs">{p.name}</td>
              <td className="px-4 py-2.5 text-white/70 font-mono text-xs">{p.type}</td>
              <td className="px-4 py-2.5">
                <span
                  className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                    p.required
                      ? "bg-red-50 text-red-600"
                      : "bg-gray-100 text-gray-500"
                  }`}
                >
                  {p.required ? "Required" : "Optional"}
                </span>
              </td>
              <td className="px-4 py-2.5 text-white/70 text-xs">{p.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);